"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Auction = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _sdkCore = require("@acala-network/sdk-core");
var _rxjs = require("rxjs");
var _chainListener = require("../utils/chain-listener");
var _storages = require("./storages");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
class Auction {
  constructor(_ref) {
    let {
      id,
      api,
      wallet,
      data
    } = _ref;
    this.api = void 0;
    this.wallet = void 0;
    this.storages = void 0;
    this.inner = void 0;
    this.chainListener = void 0;
    this.id = void 0;
    this.configs = void 0;
    this.detail$ = void 0;
    this.subscriptions = void 0;
    this.api = api;
    this.id = id;
    this.wallet = wallet;
    this.storages = (0, _storages.createAuctionStorages)(this.api);
    this.chainListener = _chainListener.ChainListener.create({
      api
    });
    this.configs = {
      auctionDurationSoftCap: this.api.consts.auctionManager.auctionDurationSoftCap.toBigInt(),
      minimumIncrementSize: _sdkCore.FixedPointNumber.fromInner(this.api.consts.auctionManager.minimumIncrementSize.toString(), 18)
    };
    this.inner = data;
    this.detail$ = new _rxjs.BehaviorSubject(this.inner);
    this.subscriptions = [this.subscribeData().subscribe({
      next: data => this.detail$.next(data),
      error: e => {
        console.error(e);
        throw e;
      }
    })];
  }
  get data$() {
    return this.detail$.pipe((0, _rxjs.filter)(i => !!i));
  }
  unscribe() {
    this.subscriptions.forEach(item => item.unsubscribe());
    this.detail$.unsubscribe();
  }
  getMinimumBidAmount(stage, startBlock, currentBlock, target, last) {
    const {
      minimumIncrementSize,
      auctionDurationSoftCap
    } = this.configs;
    let incrementSize = minimumIncrementSize;
    if (currentBlock >= startBlock + auctionDurationSoftCap) {
      // double the minimum increment size when reach soft cap
      incrementSize = minimumIncrementSize.mul(_sdkCore.FixedPointNumber.TWO);
    }
    const lastBid = last || _sdkCore.FixedPointNumber.ZERO;
    if (stage === 'REVERSE' && lastBid.isZero()) {
      return target;
    }
    return target.max(lastBid).mul(incrementSize).add(lastBid);
  }
  getActualReceiveByBidAmount(amount) {
    const {
      target,
      initialAmount,
      stage
    } = this.inner;
    if (stage === 'NORMAL') {
      return initialAmount;
    }
    if (stage === 'REVERSE') {
      return initialAmount.mul(target.amount.div(amount));
    }
    return _sdkCore.FixedPointNumber.ZERO;
  }
  getActualBidAmountByReceive(amount) {
    const {
      target,
      initialAmount,
      stage
    } = this.inner;
    if (stage === 'NORMAL') {
      return target.amount;
    }
    if (stage === 'REVERSE') {
      return target.amount.mul(initialAmount.div(amount));
    }
    return _sdkCore.FixedPointNumber.ZERO;
  }
  getCurrentStatusFormBlock(block) {
    const cancelEvent = block.events.find(item => {
      return item.event.section.toString() === 'auctionManager' && item.event.method.toString() === 'CancelAuction' && item.event.data[0].toString() === this.inner.id;
    });
    const abortEvent = block.events.find(item => {
      return item.event.section.toString() === 'auctionManager' && item.event.method.toString() === 'CollateralAuctionAborted' && item.event.data[0].toString() === this.inner.id;
    });
    const detailEvent = block.events.find(item => {
      return item.event.section.toString() === 'auctionManager' && item.event.method.toString() === 'CollateralAuctionAborted' && item.event.data[0].toString() === this.inner.id;
    });
    const dexTakeEvent = block.events.find(item => {
      return item.event.section.toString() === 'auctionManager' && item.event.method.toString() === 'DEXTakeCollateralAuction' && item.event.data[0].toString() === this.inner.id;
    });
    if (cancelEvent) {
      return 'CANCELL';
    }
    if (abortEvent) {
      return 'ABORT';
    }
    if (detailEvent) {
      return 'DEALT';
    }
    if (dexTakeEvent) {
      return 'DEX_TAKE';
    }
    return undefined;
  }
  createDexTakeBidRecord(block) {
    const event = block.events.find(item => {
      return item.event.section.toString() === 'auctionManager' && item.event.method.toString() === 'DEXTakeCollateralAuction' && item.event.data[0].toString() === this.inner.id;
    });
    if (!event) return;
    const oldVersion = event.event.data.length === 4;
    const eventData = event.event.data;
    const amount = oldVersion ? eventData[2].toBigInt() : eventData[3].toBigInt();
    const targetStableAmount = oldVersion ? eventData[3].toBigInt() : eventData[4].toBigInt();
    const stableToken = this.wallet.getPresetTokens().stableToken;
    const collateral = this.inner.collateral;
    const stableTokenAmount = _sdkCore.FixedPointNumber.fromInner(targetStableAmount.toString(), stableToken.decimals);
    const collateralAmount = _sdkCore.FixedPointNumber.fromInner(amount.toString(), collateral.decimals);
    return {
      type: 'DEX_TAKE',
      bid: {
        token: stableToken,
        amount: stableTokenAmount
      },
      lotSize: {
        token: collateral,
        amount: collateralAmount
      },
      bidPrice: collateralAmount.div(stableTokenAmount),
      timestamp: block.timestamp,
      bidder: '',
      tx: ''
    };
  }
  createBidRecord(block, collateralAmount) {
    const event = block.events.find(item => {
      return item.event.section.toString() === 'auction' && item.event.method.toString() === 'Bid' && item.event.data[0].toString() === this.inner.id;
    });
    if (!event) return;
    const eventData = event.event.data;
    const bidder = eventData[1].toString();
    const amount = eventData[2].toBigInt();
    const stableToken = this.wallet.getPresetTokens().stableToken;
    const stableTokenAmount = _sdkCore.FixedPointNumber.fromInner(amount.toString(), stableToken.decimals);
    const collateral = this.inner.collateral;
    const tx = event.phase.isApplyExtrinsic ? block.extrinsics[event.phase.asApplyExtrinsic.toNumber()] : undefined;
    return {
      type: 'DENT',
      bid: {
        token: stableToken,
        amount: stableTokenAmount
      },
      lotSize: {
        token: collateral,
        amount: collateralAmount
      },
      bidPrice: collateralAmount.div(stableTokenAmount),
      timestamp: block.timestamp,
      bidder: bidder,
      tx: tx ? tx.raw.hash.toString() : ''
    };
  }
  subscribeData() {
    return (0, _rxjs.combineLatest)({
      block: this.chainListener.block$,
      auctionDetails: this.storages.collateralAuctions(this.id).observable,
      auctionBidDetails: this.storages.auction(this.id).observable
    }).pipe((0, _rxjs.map)(_ref2 => {
      let {
        block,
        auctionDetails,
        auctionBidDetails
      } = _ref2;
      // listen collateral data from chain
      let data = _objectSpread({}, this.inner);
      if (auctionDetails && auctionDetails.isSome) {
        const details = auctionDetails.unwrap();
        const collateral = this.wallet.getToken(details.currencyId);
        const stableToken = this.wallet.getPresetTokens().stableToken;
        const startBlock = details.startTime.toBigInt();
        const currentBlock = block.block.block.header.number.toBigInt();
        const amount = _sdkCore.FixedPointNumber.fromInner(details.amount.toString(), collateral.decimals);
        const bid = auctionBidDetails === null || auctionBidDetails === void 0 ? void 0 : auctionBidDetails.unwrap();
        const endBlock = BigInt(bid.end.toString());
        const bidDetails = bid.bid.unwrapOrDefault();
        const currentBidAccount = bidDetails[0] ? bidDetails[0].toString() : undefined;
        const currentBidAmount = bidDetails[1] ? _sdkCore.FixedPointNumber.fromInner(bidDetails[1].toString(), stableToken.decimals) : undefined;
        const target = _sdkCore.FixedPointNumber.fromInner(details.target.toString(), stableToken.decimals);
        data = _objectSpread(_objectSpread({}, data), {}, {
          amount,
          winner: currentBidAccount,
          endBlock,
          minimumBidAmount: this.getMinimumBidAmount(data.stage, startBlock, currentBlock, target, currentBidAmount)
        });
      }

      // NOTE: handle bid event first when one block containes bid event and dex take event
      // FIXME: the code maybe wrong in reverse stage
      // insert bid event
      const bidRecord = this.createBidRecord(block, data.amount);
      if (bidRecord && !data.bids.find(item => item.tx === bidRecord.tx)) {
        data.bids = [bidRecord, ...data.bids];
      }

      // update current auction status in no delay
      const status = this.getCurrentStatusFormBlock(block);
      if (status) {
        data.status = status;
      }

      // insert dex take event
      if (status === 'DEX_TAKE') {
        const bidRecord = this.createDexTakeBidRecord(block);
        if (bidRecord) {
          data.bids = [bidRecord, ...data.bids];
          // clear winner beacuse no winner but dex
          data.winner = '';
        }
      }
      this.inner = data;
      return data;
    }));
  }
}
exports.Auction = Auction;